export default __webpack_public_path__ + "static/media/ic_benefits_48px.db46b826.svg";